<template>
  <UiButton
    v-if="shouldShowButton"
    :class="[
      'bg-muted ms-1 inline-flex h-3 w-3 translate-y-0.5 items-center rounded-full font-light text-black hover:bg-inherit',
      classes?.infoTrigger,
    ]"
    circle
    size="flat"
    @click="displayInfoPopup"
  >
    <UiNuxtIcon name="info" filled :size="12" />
  </UiButton>
</template>

<script setup lang="ts">
import { OverviewBuilderTypes } from "./types"

interface Props {
  infoPopup: Nullable<Partial<OverviewBuilderTypes.InfoPopup>>
  label?: Nullable<string>
  classes?: {
    infoTrigger?: string
  }
}

const props = defineProps<Props>()
const popup = useInfoPopup()

const shouldShowButton = computed(() => {
  const { infoPopup } = props
  return (
    (infoPopup?.component || infoPopup?.content || infoPopup?.description) &&
    (infoPopup.enabled !== undefined ? infoPopup.enabled : true)
  )
})

function displayInfoPopup() {
  if (!props.infoPopup) return
  popup({
    ...props.infoPopup,
    action: { label: "סגירה" },
    classes: {
      ...props.infoPopup.classes,
      title: ["text-lg", props.infoPopup.classes?.title],
      footer: cn("mt-auto", props.infoPopup.classes?.footer),
      wrapper: cn("flex min-h-64 flex-col", props.infoPopup.classes?.wrapper),
    },
    title: props.infoPopup?.title || props.label,
  })
}
</script>
